import { type ReactNode, Suspense } from "react";
import {
	createRendererModule,
	preloadDiscoveredRenderers,
	prepareDiscoveredRenderers,
} from "./renderer-module";
import { preinitRendererStyles } from "./renderer-styles";

// Registry keys are CMS aliases. Reading the type classes during module
// initialization can fail when a split server bundle evaluates this chunk first.
export const optionalBlockModules = {
	submenuUmbBlock: createRendererModule(
		() => import("../components/blocks/submenu-block"),
	),
	accordionUmbBlock: createRendererModule(async () => {
		const module = await import("../components/blocks/accordion-umb-block");
		return { default: module.AccordionUmbBlock };
	}),
	tabsUmbBlock: createRendererModule(async () => {
		const module = await import("../components/blocks/tabs-block");
		return { default: module.TabsUmbBlock };
	}),
	collapsibleUmbBlock: createRendererModule(
		() => import("../components/blocks/collapsible-block"),
	),
	formUmbBlock: createRendererModule(
		() => import("../components/blocks/form-block"),
	),
	galleryUmbBlock: createRendererModule(
		() => import("../components/blocks/gallery-block"),
	),
	carouselUmbBlock: createRendererModule(
		() => import("../components/blocks/carousel-block"),
	),
	videoUmbBlock: createRendererModule(
		() => import("../components/blocks/video-block"),
	),
	keyFigureUmbBlock: createRendererModule(
		() => import("../components/blocks/key-figure-block"),
	),
};

export const optionalPageModules = {
	eventUmbPage: createRendererModule(
		() => import("../components/pages/event-umb-page"),
	),
	eventListingUmbPage: createRendererModule(
		() => import("../components/pages/event-listing-umb-page"),
	),
	newsListingUmbPage: createRendererModule(
		() => import("../components/pages/news-listing-umb-page"),
	),
	newsUmbPage: createRendererModule(
		() => import("../components/pages/news-umb-page"),
	),
	searchUmbPage: createRendererModule(async () => {
		const module = await import("../components/pages/search-umb-page");
		return { default: module.SearchUmbPage };
	}),
	restrictedAccessUmbPage: createRendererModule(
		() => import("../components/pages/restricted-access-umb-page"),
	),
	loginUmbPage: createRendererModule(
		() => import("../components/pages/login-umb-page"),
	),
	blogStartUmbPage: createRendererModule(
		() => import("../components/pages/blog-start-umb-page"),
	),
	blogPostUmbPage: createRendererModule(
		() => import("../components/pages/blog-post-umb-page"),
	),
};

const rendererModules = { ...optionalBlockModules, ...optionalPageModules };
export function preloadRendererModules(value: unknown) {
	preinitRendererStyles(value);
	return preloadDiscoveredRenderers(value, rendererModules);
}

function ReadyRenderers({
	value,
	children,
}: {
	value: unknown;
	children: ReactNode;
}) {
	prepareDiscoveredRenderers(value, rendererModules);
	return children;
}
export function RendererModuleBoundary({
	value,
	children,
}: {
	value: unknown;
	children: ReactNode;
}) {
	return (
		<Suspense fallback={null}>
			<ReadyRenderers value={value}>{children}</ReadyRenderers>
		</Suspense>
	);
}
